// ==================== PUBLIC LAYOUT ====================
// Used for: Landing page, About, Contact, Pricing, Features, etc.

import { Outlet } from 'react-router-dom';
import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';

const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-(--color-midnight-navy)">
      <Header />
      
      {/* Main Content - Add padding for fixed header */}
      <main className="flex-1 pt-[4.5rem] lg:pt-24">
        <Outlet />
      </main>
      
      <Footer />
    </div>
  );
};

export { PublicLayout };

